const isSafari = () => /^((?!chrome|android|CriOS).)*safari/i.test(navigator.userAgent);
const isFirefox = () => navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
export const bannedBrowser = () => isSafari() || isFirefox();
